import React, { useState, useEffect } from 'react';
import Notifications, { notify } from 'react-notify-toast';
import Spinner from './Spinner';
import Images from './Images';
import Buttons from './Buttons';
import WakeUp from './WakeUp';
import { API_URL } from './config';
import './Upload.css';

const toastColor = {
  background: '#505050',
  text: '#fff',
};

export default function Upload({ onChange, uploaded } ) {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState([]);
  const [doc, setDoc] = useState('');

  const toast = notify.createShowQueue();

  const filter = (id) => images.filter((image) => image.public_id !== id);

  const removeImage = (id) => {
    setImages(filter(id));
  };

  const onError = (id) => {
    toast('Oops, something went wrong', 'custom', 5000, toastColor);
    setImages(filter(id));
  };

  const onChangeHandler = (e) => {
    const errs = [];
    const files = Array.from(e.target.files);

    if (files.length > 3) {
      const msg = 'Only 3 images can be uploaded at a time';
      return toast(msg, 'custom', 5000, toastColor);
    }

    const formData = new FormData();
    const types = ['text/xml'];

    files.forEach((file, i) => {
      if (types.every((type) => file.type !== type)) {
        errs.push(`'${file.type}' is not a supported format`);
      }

      if (file.size > 150000) {
        errs.push(`'${file.name}' is too large, please pick a smaller file`);
      }

      formData.append('file', file);
    });

    if (errs.length) {
      return errs.forEach((err) =>
          toast(err, 'custom', 5000, toastColor)
      );
    }

    setUploading(true);

    fetch(`${API_URL}/api/upload`, {
      method: 'POST',
      body: formData,
    })
        .then((res) => {
          if (!res.ok) {
            throw res;
          }
          return res.text();
        })
        .then((stanza) => {
          setDoc(stanza);
          setUploading(false);
          onChange(stanza);
        })
        .catch((err) => {
          err.json().then((e) => {
            toast(e.message, 'custom', 5000, toastColor);
            setUploading(false);
          });
          onChange(false);
        });
  };

  useEffect(() => {
    fetch(API_URL)
        .then((res) => {
          if (res.ok) {
            setLoading(false);
          } else {
            const msg = 'Something went wrong with Backend';
            toast(msg, 'custom', 5000, toastColor);
          }
        });
  }, []);

  const content = () => {
    if (loading) {
      return <WakeUp />;
    }
    if (uploading) {
      return <Spinner />;
    }
    if (images.length > 0) {
      return (
          <Images
              images={images}
              removeImage={removeImage}
              onError={onError}
          />
      );
    }
    if (doc || uploaded) {
      return (
          <>
            <Buttons type="upload" onChange={onChangeHandler} />
            <Buttons type="download" onChange={onChangeHandler} />
            <Buttons type="publish" onChange={onChangeHandler} />
          </>
      );
    }
    return <Buttons type="upload" onChange={onChangeHandler} />;
  };

  return (
      <div className="buttons">
        <Notifications />
        {content()}
      </div>
  );
}
